const normalize = (value: unknown) => String(value ?? '').trim();

export const isResolvedMemberLabel = (
  memberUuid?: string | null,
  label?: string | null,
) => {
  const safeUuid = normalize(memberUuid);
  const safeLabel = normalize(label);
  return Boolean(safeLabel && safeLabel !== safeUuid);
};
